module.exports = __webpack_public_path__ + "img/aboutBg.fe5ac592.jpg";